import * as React from 'react';
import { useAccount, State } from '@grandvisionhq/auth';
import { H1, Text, Spinner } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { AnonymousCancelSubscriptionContainer } from './AnonymousFlow/AnonymousCancelSubscriptionContainer.js';
import { AuthenticatedCancelSubscriptionContainer } from './AuthenticatedFlow/AuthenticatedCancelSubscriptionContainer.js';

const CancelSubscriptionRouter = ({ subscriptionId , nextPossibleTerminationDate , subscriptionInterval  })=>{
    const { getLabel  } = useIntl();
    const authState = useAccount();
    const isLoggedIn = authState === State.AuthState.LoggedIn;
    // We want to show a loader if the authstate is Unknown and a subscriptionId is provided.
    // We do not want to show the loader longer then 3 seconds and if there is no response yet, we can fallback to the anonymous flow.
    // Assumption is that if a subscriptionId is provided, the intention is to use the authenticated flow.
    const [isLoading, setIsLoading] = React.useState(false);
    React.useEffect(()=>{
        let timer;
        if (authState === 'UNKNOWN' && subscriptionId) {
            setIsLoading(true);
            timer = setTimeout(()=>{
                setIsLoading(false);
            }, 3000);
        } else {
            setIsLoading(false);
        }
        return ()=>{
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [
        authState,
        subscriptionId
    ]);
    const labels = {
        title: getLabel('cancelSubscription.title'),
        description: getLabel('cancelSubscription.description')
    };
    const getComponent = ()=>{
        if (isLoading && subscriptionId) {
            return /*#__PURE__*/ React.createElement("div", {
                className: "cancel-subscription__loader"
            }, /*#__PURE__*/ React.createElement(Spinner, {
                "aria-label": getLabel('common.loadingText')
            }));
        }
        if (isLoggedIn && subscriptionId) {
            return /*#__PURE__*/ React.createElement(AuthenticatedCancelSubscriptionContainer, {
                subscriptionId: subscriptionId,
                nextPossibleTerminationDate: nextPossibleTerminationDate,
                subscriptionInterval: subscriptionInterval
            });
        }
        return /*#__PURE__*/ React.createElement(AnonymousCancelSubscriptionContainer, null);
    };
    return /*#__PURE__*/ React.createElement("section", {
        className: "cancel-subscription__container"
    }, /*#__PURE__*/ React.createElement(H1, {
        variant: "heading-large"
    }, labels.title), /*#__PURE__*/ React.createElement(Text, {
        variant: "body"
    }, labels.description), getComponent());
};

export { CancelSubscriptionRouter };
//# sourceMappingURL=CancelSubscriptionRouter.js.map
